/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMerchantIssueSummaryData
 */
export interface GoogleMerchantIssueSummaryData {
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantIssueSummaryData
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantIssueSummaryData
     */
    severity?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantIssueSummaryData
     */
    reportingContext?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantIssueSummaryData
     */
    countryCode?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantIssueSummaryData
     */
    productCount?: number;
}

/**
 * Check if a given object implements the GoogleMerchantIssueSummaryData interface.
 */
export function instanceOfGoogleMerchantIssueSummaryData(value: object): value is GoogleMerchantIssueSummaryData {
    return true;
}

export function GoogleMerchantIssueSummaryDataFromJSON(json: any): GoogleMerchantIssueSummaryData {
    return GoogleMerchantIssueSummaryDataFromJSONTyped(json, false);
}

export function GoogleMerchantIssueSummaryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantIssueSummaryData {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'reportingContext': json['reportingContext'] == null ? undefined : json['reportingContext'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'productCount': json['productCount'] == null ? undefined : json['productCount'],
    };
}

export function GoogleMerchantIssueSummaryDataToJSON(json: any): GoogleMerchantIssueSummaryData {
    return GoogleMerchantIssueSummaryDataToJSONTyped(json, false);
}

export function GoogleMerchantIssueSummaryDataToJSONTyped(value?: GoogleMerchantIssueSummaryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'severity': value['severity'],
        'reportingContext': value['reportingContext'],
        'countryCode': value['countryCode'],
        'productCount': value['productCount'],
    };
}

